// Recovered compiled webpack factory 21010. Edit this function expression; run npm run build.
(e, t, r) => {
  "use strict";
  r.d(t, { AS: () => u, aj: () => c, s5: () => l });
  var n = r(61571),
    a = r(43275),
    o = r(85236);
  let i = {},
    s = {};
  function l(e, t) {
    ((i[e] = i[e] || []), i[e].push(t));
  }
  function u(e, t) {
    if (!s[e]) {
      s[e] = !0;
      try {
        t();
      } catch (t) {
        n.T && a.Yz.error(`Error while instrumenting ${e}`, t);
      }
    }
  }
  function c(e, t) {
    let r = e && i[e];
    if (r)
      for (let i of r)
        try {
          i(t);
        } catch (t) {
          n.T &&
            a.Yz.error(
              `Error while triggering instrumentation handler.
Type: ${e}
Name: ${(0, o.qQ)(i)}
Error:`,
              t,
            );
        }
  }
}
